/**
 * Normalises anything thrown (Error, Supabase error, string, unknown) into a
 * human-readable message so components can drop loosely-typed catch clauses.
 */
export function getErrorMessage(error: unknown, fallback = "Something went wrong"): string {
  if (!error) return fallback;
  if (typeof error === "string") return error || fallback;
  if (error instanceof Error) return error.message || fallback;
  if (typeof error === "object") {
    const maybe = error as { message?: unknown; error_description?: unknown; error?: unknown };
    if (typeof maybe.message === "string" && maybe.message) return maybe.message;
    if (typeof maybe.error_description === "string" && maybe.error_description) return maybe.error_description;
    if (typeof maybe.error === "string" && maybe.error) return maybe.error;
  }
  return fallback;
}
